import { createClient as createSupabaseClientLib, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL as string
const supabaseAnonKey = (import.meta as any).env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.')
}

export const createSupabaseClient = (): SupabaseClient => createSupabaseClientLib(supabaseUrl, supabaseAnonKey)
export const supabase: SupabaseClient = createSupabaseClient()
export { createSupabaseClient as createClient } 